
import VerticalTabs from "../../components/pos/VerticalTabs.vue";
import { CONSTANTS } from "../../constants";

export default {
  name: "TMSPage",
  data: () => ({
    BANNER_DETAILS: CONSTANTS.POS_BANNER_DETAILS,
    REVIEWS: CONSTANTS.REVIEWS,
    features: [
      {
        name: "Easy to Use and Customizable",
        description: [
          {
            title: "Intuitive Interface",
            data: " Benefit from an easy-to-use UI that minimizes the learning curve, allowing for faster operations and quick staff training.",
          },
          {
            title: "Personalized Workflows",
            data: "Customize the POS system to match your specific business needs and processes.",
          },
          {
            title: "Speedy Transactions",
            data: " Ensure fast and efficient checkout experiences, enhancing customer satisfaction and reducing wait times.",
          },
        ],
        imageName: "/pos/pos1.png",
      },
      {
        name: "Manage Multiple Stores with a Single Solution On-the-Go",
        description: [
          {
            title: "Centralized Management",
            data: "Oversee inventory, sales, and purchases for each store through a single platform, accessible via mobile app, CMS, and desktop app.",
          },
          {
            title: "Barcode Integration",
            data: " Streamline operations with barcode scanner integration for quick and accurate product management.",
          },
          {
            title: "Comprehensive Order Management",
            data: " Handle the entire product lifecycle from ordering to sales seamlessly.",
          },
        ],
        imageName: "/pos/pos2.png",
      },
      {
        name: "Expand Your Business",
        description: [
          {
            title: "Market Differentiation",
            data: "Stand out in the market by leveraging our POS system to build a robust business network.",
          },
          {
            title: "Branding Tools",
            data: " Utilize our website builder to enhance your brand presence and attract more customers.",
          },
          {
            title: "Growth Opportunities",
            data: " Tap into new markets and expand your customer base effortlessly.",
          },
        ],
        imageName: "/pos/pos3.png",
      },
      {
        name: "Integration Across Multiple Sales Channels",
        description: [
          {
            title: "Unified Sales Management",
            data: " Manage sales from offline stores, online stores, and e-commerce platforms like Myntra and Amazon.",
          },
          {
            title: "Social Media Integration",
            data: " Leverage social media sales channels to reach a wider audience.",
          },
          {
            title: "On-Demand Delivery",
            data: " Use AiBuddha's on-demand delivery app for seamless shipment and packaging management.",
          },
        ],
        imageName: "/pos/pos4.png",
      },
      {
        name: "Your POS, Your Control",
        description: [
          {
            title: "Employee Access Control",
            data: " Set role-based permissions to control what employees can access and modify within the system.",
          },
          {
            title: "Detailed Data Tracking",
            data: " Monitor product movements and updates with precision.",
          },
          {
            title: "Comprehensive Reporting",
            data: " Generate detailed reports and analytics to gain insights into sales performance and inventory levels.",
          },
        ],
        imageName: "/pos/pos5.png",
      },
      {
        name: "Miscellaneous Features",
        description: [
          {
            title: "Email Functionality",
            data: " Send emails directly from the POS system to vendors and customers.",
          },
          {
            title: "Template Management",
            data: "Create and customize email and PDF templates for consistent and professional communication.",
          },
          {
            title: "Tax Management",
            data: "Efficiently handle tax calculations and compliance, ensuring accurate and up-to-date records.",
          },
        ],
        imageName: "/pos/pos6.png",
      },
    ],
  }),
  head() {
    return {
      title: "Point of sale system by AiBuddha",
      description: "Optimise your Sales Operations with POS by AiBuddha",
    };
  },
};
